import { Component, OnChanges, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, combineLatest, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ViewerCanvasComponent } from '../viewer-canvas/viewer-canvas.component';
import { ViewerBaseComponent } from '../viewer-shared/viewer-base.component';
import { ViewerVideoComponent } from '../viewer-video/viewer-video.component';

@Component({
  selector: 'zbp-viewer-video-canvas',
  templateUrl: './viewer-video-canvas.component.html',
  styleUrls: ['./viewer-video-canvas.component.scss',
    '../viewer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ViewerCanvasComponent, ViewerVideoComponent]
})
export class ViewerVideoCanvasComponent extends ViewerBaseComponent implements OnChanges {
  private videoLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private imageLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   *
   */
  constructor() {
    super();

  }

  ngOnChanges(): void {
    combineLatest([this.videoLoaded$, this.imageLoaded$])
      .pipe(
        catchError((err) => {
          this.withError.emit(err);
          return of(null);
        }),
        map(values => values?.reduce((ret, value) => ret && value, true) || false)
      )
      .subscribe((loaded) => {
        if (loaded) {
          this.loaded.emit();
        }
      });
  }

  completedVideoLoading(): void {
    this.videoLoaded$.next(true);
  }

  completeImageLoading(): void {
    this.imageLoaded$.next(true);
  }
}
